import type { PartnerConfig } from "@/content/partners/types"

export const BUSER_PARTNER_SLUG = "buser"

export const BUSER_LOGO_PATH = "/partners/buser/logo.svg"

export const buserBrand = {
  accent: "#f11075",
  accentDark: "#b00051",
  accentLight: "#f563a0",
  ringFrom: "#f11075",
  ringTo: "#e6006a",
  benefit: "#4ade80",
  benefitForeground: "#002a50",
} as const

export const buserPartnerConfig: PartnerConfig = {
  slug: BUSER_PARTNER_SLUG,
  name: "Buser",
  fullName: "Buser",
  logoPath: BUSER_LOGO_PATH,
  benefitMode: "next_band",
  isActive: true,
  metadata: {
    website: "https://www.buser.com.br/",
    industry: "mobilidade",
  },
}

export const buserPartnerContent = {
  ...buserPartnerConfig,
  tagline: "Viagens de ônibus com praticidade, segurança e preço justo",
  websiteUrl: "https://www.buser.com.br/",
  benefitHeadline: "Benefício para colaboradores",
  heroHeadline: "Colaboradores da Buser têm desconto extra na energia",
  heroSubtitle: "Energia solar por assinatura, sem obra e sem investimento inicial.",
  partnershipIntro:
    "Colaboradores da Buser têm desconto extra na energia por assinatura — cadastro simples, benefício automático.",
  partnershipTitle: "Buser e energia limpa, juntos",
} as const
